import { Router } from "@angular/router";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { UserserviceService } from "src/app/Services/userservice.service";
import { HttpClient, HttpEvent } from "@angular/common/http";
import { HttpEventType } from "@angular/common/http";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { SelectionRephraseAIComponent } from "../selection-rephraseAi-dialog/selection-rephraseAi-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { GenerateKeyword } from "../generate-keyword/generate-keyword.component";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  buildEmbedUrl,
  buildIframeEmbedCode,
  DEFAULT_EMBED_SIZES,
  EmbedContentType,
  parseIframeEmbedCode,
} from "src/app/utils/embed.util";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { FlowQueryModel } from "src/app/models/flowquerymodel";

type BlogJourneyTabId =
  | "title"
  | "type"
  | "embed"
  | "media"
  | "description"
  | "details";

interface BlogJourneyTab {
  id: BlogJourneyTabId;
  label: string;
}

@Component({
  selector: "app-create-blog",
  templateUrl: "./create-blog.component.html",
  styleUrls: ["./create-blog.component.scss"],
})
export class CreateBlogComponent implements OnInit {
  userData: any;
  keywords: string[] = [];
  keyword: string;
  showImage: boolean;
  noResultReturned!: boolean;
  showDefaultImage: boolean;
  profilePicture: any;
  email: any;
  phone: any;
  uname: any;
  name: any;
  posterURI: any;
  fileData: File;
  isLoading: boolean;
  progress: number;
  fileName: string;
  coverPageURI: string;
  sffilename: any;
  currenttitlelenght = 0;
  currentdesclenght = 0;
  title: string;
  imageURI: null;
  enableButton: boolean;
  duration: any;
  rowKey: any;
  partitionKey: any;
  authorName: any;
  isUploading: boolean;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  addOnBlur = true;
  maxtitlelenght = 150;
  maxdesclenght = 500;
  @Input() description: string = "";

  originalTitleText!: string;
  repharaseButtonTitleText: string = "Rephrase text with AI";
  isTitleRephrased: boolean = false;
  isTitleRephraseInProgress: boolean = false;
  blogData: any;
  isBlogPublished!: boolean;
  featureOnProfile: boolean = false;
  enableEmbed = false;
  embedCode = "";
  embedPreviewUrl: SafeResourceUrl | null = null;

  embedContentType: EmbedContentType | null = null;
  embedMethod: "search" | "paste" | null = null;
  searchQuery = "";
  searchResults: any[] = [];
  selectedEmbedContent: any = null;
  isSearchingEmbed = false;
  searchAttempted = false;

  activeJourneyTab: BlogJourneyTabId = "title";
  journeyTabs: BlogJourneyTab[] = [
    { id: "title", label: "Title" },
    { id: "media", label: "Media" },
    { id: "description", label: "Description" },
    { id: "details", label: "Details" },
  ];
  private lastEmbedPreviewSrc: string | null = null;
  private cachedEmbedCodeForValidation = "";
  private cachedEmbedCodeValid = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private userserviceService: UserserviceService,
    private cdr: ChangeDetectorRef,
    private toastManager: ToastrService,
    public dialog: MatDialog,
    private flowServiceService: FlowServiceService,
    private mediaUploadService: MediaUploadService,
    private sanitizer: DomSanitizer
  ) {
    this.title = "";
    this.description = "";
  }

  get isFirstJourneyTab(): boolean {
    return this.activeJourneyTab === this.journeyTabs[0]?.id;
  }

  get isLastJourneyTab(): boolean {
    return (
      this.activeJourneyTab ===
      this.journeyTabs[this.journeyTabs.length - 1]?.id
    );
  }

  trackJourneyTab(_index: number, tab: BlogJourneyTab): string {
    return tab.id;
  }

  private refreshJourneyTabs(): void {
    const tabs: BlogJourneyTab[] = [{ id: "title", label: "Title" }];
    if (this.enableEmbed) {
      tabs.push({ id: "type", label: "Type" }, { id: "embed", label: "Embed" });
    }
    tabs.push(
      { id: "media", label: "Media" },
      { id: "description", label: "Description" }
    );
    tabs.push({ id: "details", label: "Details" });
    this.journeyTabs = tabs;

    if (!tabs.some((t) => t.id === this.activeJourneyTab)) {
      this.activeJourneyTab = "title";
    }
  }

  ngOnInit() {
    this.flowServiceService.setScrollTop();
    this.noResultReturned = false;

    try {
      this.userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    } catch {
      this.userData = null;
    }

    if (!this.userData) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: "/create-blog" },
      });
      return;
    }

    this.profilePicture = this.userData.profilePicUrl;
    this.authorName = `@${this.userData.userName}`;
    this.titleChanged();
    this.refreshJourneyTabs();

    try {
      this.blogData = JSON.parse(
        localStorage.getItem("selectedBlogContent") || "null"
      );
    } catch {
      this.blogData = null;
    }

    if (this.blogData) {
      this.setBlogData(this.blogData);
    }
  }

  closeToHome(): void {
    this.router.navigate(["/bulbguide"]);
  }

  isStep1Valid(): boolean {
    return !!(this.title && this.title.trim());
  }

  isStep2Valid(): boolean {
    return !!this.embedContentType;
  }

  isStep3Valid(): boolean {
    if (!this.embedMethod) {
      return false;
    }
    if (this.embedMethod === "search") {
      return !!this.selectedEmbedContent && !!this.embedCode?.trim();
    }
    const code = this.embedCode || "";
    if (code === this.cachedEmbedCodeForValidation) {
      return this.cachedEmbedCodeValid;
    }
    this.cachedEmbedCodeForValidation = code;
    this.cachedEmbedCodeValid = !!parseIframeEmbedCode(code)?.src;
    return this.cachedEmbedCodeValid;
  }

  canSubmit(): boolean {
    return !!(
      this.title &&
      this.description &&
      this.coverPageURI &&
      this.authorName &&
      this.duration
    );
  }

  isMediaValid(): boolean {
    return !!this.coverPageURI && !this.isLoading;
  }

  isDescriptionValid(): boolean {
    return !!this.description?.trim();
  }

  isDetailsValid(): boolean {
    return !!this.authorName && Number(this.duration) > 0;
  }

  isJourneyStageComplete(tabId: BlogJourneyTabId): boolean {
    switch (tabId) {
      case "title":
        return this.isStep1Valid();
      case "type":
        return this.isStep2Valid();
      case "embed":
        return this.isStep3Valid();
      case "media":
        return this.isMediaValid();
      case "description":
        return this.isDescriptionValid();
      case "details":
        return this.isDetailsValid();
      default:
        return false;
    }
  }

  canAccessJourneyTab(tabId: BlogJourneyTabId): boolean {
    const targetIndex = this.journeyTabs.findIndex((t) => t.id === tabId);
    if (targetIndex <= 0) {
      return true;
    }
    for (let i = 0; i < targetIndex; i++) {
      if (!this.isJourneyStageComplete(this.journeyTabs[i].id)) {
        return false;
      }
    }
    return true;
  }

  setActiveJourneyTab(tabId: BlogJourneyTabId): void {
    if (!this.canAccessJourneyTab(tabId)) {
      return;
    }
    this.activeJourneyTab = tabId;
  }

  goToPreviousJourneyTab(): void {
    const idx = this.journeyTabs.findIndex((t) => t.id === this.activeJourneyTab);
    if (idx > 0) {
      this.activeJourneyTab = this.journeyTabs[idx - 1].id;
    }
  }

  goToNextJourneyTab(): void {
    if (!this.canLeaveCurrentTab()) {
      return;
    }
    const idx = this.journeyTabs.findIndex((t) => t.id === this.activeJourneyTab);
    if (idx >= 0 && idx < this.journeyTabs.length - 1) {
      this.activeJourneyTab = this.journeyTabs[idx + 1].id;
    }
  }

  canLeaveCurrentTab(): boolean {
    switch (this.activeJourneyTab) {
      case "title":
        return this.isStep1Valid();
      case "type":
        return this.isStep2Valid();
      case "embed":
        return this.isStep3Valid();
      case "media":
        return this.isMediaValid();
      case "description":
        return this.isDescriptionValid();
      default:
        return true;
    }
  }

  onEmbedIntentChange(enabled: boolean | string): void {
    const next = enabled === true || enabled === "true";
    if (this.enableEmbed === next) {
      return;
    }
    this.enableEmbed = next;
    if (!next) {
      this.clearEmbedWizardState();
      this.embedCode = "";
      this.embedPreviewUrl = null;
      this.lastEmbedPreviewSrc = null;
      this.cachedEmbedCodeForValidation = "";
      this.cachedEmbedCodeValid = false;
    }
    this.refreshJourneyTabs();
  }

  onEmbedContentTypeChange(type: EmbedContentType): void {
    if (this.embedContentType === type) {
      return;
    }
    this.embedContentType = type;
    this.clearSearchSelection();
    this.embedMethod = null;
    this.embedCode = "";
    this.embedPreviewUrl = null;
    this.lastEmbedPreviewSrc = null;
  }

  onEmbedMethodChange(method: "search" | "paste"): void {
    if (this.embedMethod === method) {
      return;
    }
    this.embedMethod = method;
    this.clearSearchSelection();
    if (method === "search") {
      this.embedCode = "";
      this.embedPreviewUrl = null;
      this.lastEmbedPreviewSrc = null;
    }
  }

  clearEmbedWizardState(): void {
    this.embedContentType = null;
    this.embedMethod = null;
    this.clearSearchSelection();
  }

  clearSearchSelection(): void {
    this.searchQuery = "";
    this.searchResults = [];
    this.selectedEmbedContent = null;
    this.searchAttempted = false;
    this.isSearchingEmbed = false;
  }

  searchEmbedContent(): void {
    if (!this.embedContentType || !this.userData) {
      return;
    }

    const query = (this.searchQuery || "").trim();
    this.isSearchingEmbed = true;
    this.searchAttempted = true;
    this.searchResults = [];
    this.selectedEmbedContent = null;

    const flowQueryModel = new FlowQueryModel({
      searchString: query,
      userEmail: this.userData.emailAddress,
      pageIndex: 0,
    });

    const request$ =
      this.embedContentType === "bundle"
        ? this.flowServiceService.searchInBundles(flowQueryModel)
        : this.flowServiceService.searchInFlows(flowQueryModel);

    request$.subscribe({
      next: (data) => {
        this.isSearchingEmbed = false;
        const items = data?.flows || data?.bundles || [];
        this.searchResults = Array.isArray(items) ? items : [];
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.isSearchingEmbed = false;
        this.searchResults = [];
        this.toastManager.error(
          this.embedContentType === "bundle"
            ? "Failed to search bundles. Please try again."
            : "Failed to search flows. Please try again."
        );
        console.error("Error searching embed content:", error);
        this.cdr.detectChanges();
      },
    });
  }

  selectEmbedContent(item: any): void {
    if (!item || !this.embedContentType) {
      return;
    }

    const rowKey = item.rowKey || item.RowKey;
    const contentTitle = item.title || item.Title || "content";
    if (!rowKey) {
      this.toastManager.warning("Selected content is missing an id.");
      return;
    }

    this.selectedEmbedContent = item;
    const embedUrl = buildEmbedUrl(
      this.embedContentType,
      rowKey,
      contentTitle,
      "full"
    );
    const size = DEFAULT_EMBED_SIZES[0];
    this.embedCode = buildIframeEmbedCode(embedUrl, size.width, size.height);
    this.updateEmbedPreview();
  }

  isEmbedContentSelected(item: any): boolean {
    if (!this.selectedEmbedContent || !item) {
      return false;
    }
    const selectedKey =
      this.selectedEmbedContent.rowKey || this.selectedEmbedContent.RowKey;
    const itemKey = item.rowKey || item.RowKey;
    return !!selectedKey && selectedKey === itemKey;
  }

  getContentThumb(item: any): string {
    return item?.url || item?.Url || item?.coverImage || item?.CoverImage || "";
  }

  getContentTitle(item: any): string {
    return item?.title || item?.Title || "Untitled";
  }

  getEmbedSummaryLabel(): string {
    if (!this.enableEmbed) {
      return "No embed";
    }
    const typeLabel =
      this.embedContentType === "bundle"
        ? "Bundle"
        : this.embedContentType === "flow"
        ? "Flow"
        : "Embed";
    if (this.selectedEmbedContent) {
      return `${typeLabel}: ${this.getContentTitle(this.selectedEmbedContent)}`;
    }
    return `${typeLabel} (pasted code)`;
  }

  addKeyword(event: any): void {
    const input = event.input;
    const value = event.value;
    console.log(value);
    console.log(input);
    if (value && !this.keywords.includes(value)) {
      this.keywords.push(value);
      if (input) {
        input.value = "";
      }
    }
  }

  updateInputField(selectedKeyword: string) {
    this.keyword = selectedKeyword;
  }

  removeKeyword(index: number) {
    this.keywords.splice(index, 1);
  }

  editKeyword(index: number, key: string) {
    this.keyword = key;
    this.keywords.splice(index, 1);
  }

  isImageOrVideo(url) {
    if (
      url.includes("JPEG") ||
      url.includes("jpeg") ||
      url.includes("JPG") ||
      url.includes("JFIF") ||
      url.includes("PNG") ||
      url.includes("jfif") ||
      url.includes("png") ||
      url.includes("tiff") ||
      url.includes("TIFF") ||
      url.includes("TIF") ||
      url.includes("tif") ||
      url.includes("jpg")
    ) {
      this.showImage = true;
    }
  }

  createFlow() {
    this.router.navigate(["/create-guide"]);
  }

  submit() {
    this.isBlogPublished = true;
    var blogModel = {
      coverImage: this.coverPageURI,
      description: this.description,
      title: this.title,
      authorName: this.authorName,
      duration: this.duration ? String(this.duration) : "",
      partitionKey: this.userData.partitionKey,
      rowKey: this.blogData ? this.blogData.rowKey : "",
      hashtags: this.keywords.join(", "),
      featureOnProfile: this.featureOnProfile,
      embedCode: this.enableEmbed ? this.embedCode.trim() : "",
    };

    console.log(blogModel);

    if (this.userData) {
      this.isUploading = true;
      this.progress = 0;
      this.flowServiceService
        .publishBlog(blogModel, this.userData.emailAddress)
        .subscribe({
          next: (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                console.log("Request sent to server.");
                break;

              case HttpEventType.UploadProgress:
                this.progress = Math.round(
                  (95 * event.loaded) / (event.total || 1)
                );
                console.log(`Progress: ${this.progress}%`);
                break;

              case HttpEventType.Response:
                const result = event.body;
                console.log("Upload complete:", event.body);
                localStorage.setItem(
                  "selectedBlogContent",
                  JSON.stringify(result)
                );
                this.cdr.detectChanges();

                setTimeout(() => {
                  this.progress = 100;
                  console.log("set is loading");
                  this.noResultReturned = false;
                  this.isBlogPublished = false;
                  this.toastManager.success("Blog successfully published");
                  this.router.navigate([
                    "/blog/" + this.getTitle(result.title),
                  ]);
                  this.resetProgress();
                }, 1000);

                break;

              default:
                console.log("Unhandled event:", event);
            }
          },
          error: (err) => {
            console.error("Error uploading:", err);
            this.resetProgress();
          },
        });
    } else {
      localStorage.setItem("selectedBlogContent", JSON.stringify(blogModel));
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }

    this.noResultReturned = false;
  }

  getTitle(title: any) {
    return title.replace(/\s+/g, "-");
  }

  resetProgress() {
    setTimeout(() => {
      this.progress = 0;
      this.isUploading = false;
    }, 500);
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }
  removePicture() {
    this.profilePicture = null;
  }
  setPosterImage(fileData) {
    let url = fileData.replace("." + this.getExtention(fileData), ".jpg");
    this.posterURI = url;
  }

  getExtention(fileData) {
    return fileData.slice(((fileData.lastIndexOf(".") - 1) >>> 0) + 2);
  }

  openLink(url) {
    url = "https://" + url;
    window.open(url);
  }

  async selectFiles(event: any, source: string) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.fileData = <File>event.target.files[0];
      this.isLoading = true;
      const imageExtensions = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "jfif",
        "tiff",
        "tif",
        "pdf",
        "bmp",
        "webp",
        "svg",
        "heic",
        "heif",
        "raw",
        "arw",
        "cr2",
        "nef",
        "orf",
        "rw2",
        "dng",
        "psd",
        "ico",
        "exif",
        "pjpeg",
        "ppm",
        "pgm",
        "pbm",
        "pnm",
        "xpm",
        "tga",
        "pcx",
        "jp2",
        "jpx",
        "eps",
        "ai",
      ];
      const videoExtensions = [
        "mp4",
        "mov",
        "wmv",
        "flv",
        "avchd",
        "webm",
        "mkv",
        "vob",
        "ogv",
        "gifv",
        "m4p",
        "m4v",
        "3gp",
        "3g2",
        "amv",
        "nsv",
        "ogg",
        "f4v",
        "f4p",
        "f4a",
        "f4b",
        "avi",
        "mts",
        "m2ts",
        "ts",
        "mpg",
        "mpeg",
        "rm",
        "rmvb",
        "divx",
        "xvid",
        "asf",
        "mxf",
        "dv",
        "h264",
        "h265",
        "vp8",
        "vp9",
        "prores",
        "swf",
        "dat",
        "bik",
        "av1",
        "vro",
        "svi",
      ];

      const isImageOrPdf = imageExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );
      const isVideo = videoExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(
            this.fileData
          );
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.isLoading = false;
          this.noResultReturned = false;
          this.fileName = "";
          this.toastManager.warning(
            error?.message || this.mediaUploadService.uploadTooLargeMessage()
          );
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);

      const uploadUrl = isImageOrPdf
        ? environment.apiBaseUrl + environment.uploadImageUrl
        : environment.apiBaseUrl + environment.uploadVideoUrl;

      this.http
        .post(uploadUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                if (event.total) {
                  this.progress = Math.round(
                    (event.loaded / event.total) * 100
                  );
                }
                break;
              case HttpEventType.Response:
                this.handleFileUpload(event.body, isImageOrPdf, source);
                break;
            }
          },
          (error) => {
            this.isLoading = false;
            this.noResultReturned = false;
            this.fileName = "";
            this.toastManager.warning(
              this.mediaUploadService.uploadTooLargeMessage()
            );
            console.error("Upload error:", error);
          }
        );
    }
  }

  handleFileUpload(response: any, isImageOrPdf: boolean, source: string) {
    this.isLoading = false;
    this.noResultReturned = false;
    const mediaUploadStatus = response;

    if (mediaUploadStatus) {
      if (isImageOrPdf) {
        this.showImage = true;
        if (source === "cp") {
          this.fileName = this.fileData.name;
          this.coverPageURI =
            environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
          this.activeJourneyTab = "description";
        } else if (source === "sd") {
          this.sffilename = mediaUploadStatus.fileName;
        }
      }
      this.toastManager.success("File has been uploaded successfully.");
      this.progress = 100;
    } else {
      this.toastManager.error("Upload failed");
    }
  }

  titleChanged() {
    this.title = this.title.trim();

    if (this.title.length == this.maxtitlelenght) {
      this.title = this.title.substring(0, this.title.length);
    }

    if (this.currenttitlelenght <= this.maxtitlelenght)
      this.currenttitlelenght = this.title.length;

    this.setIsDisable();
  }

  setIsDisable() {
    if (
      this.currenttitlelenght > 0 &&
      this.currentdesclenght > 0 &&
      this.imageURI != null
    ) {
      this.enableButton = false;
    } else {
      this.enableButton = true;
    }
  }

  descChanged() {
    if (!this.description) {
      this.currentdesclenght = 0;
      this.setIsDisable();
      return;
    }
    // Don't mutate description here — trimming on every keystroke can loop with Quill
    if (this.currentdesclenght <= this.maxdesclenght) {
      this.currentdesclenght = this.description.length;
    }
    this.setIsDisable();
  }

  originalContentTitleText!: string;
  repharaseButtonText: string = "Rephrase text with AI";
  isRephrased: boolean = false;
  isRephraseInProgress: boolean = false;

  GoToOriginalText() {
    this.description = this.originalContentTitleText;
  }
  openDescrptionRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.description },
    });
    if (!this.isTitleRephrased) {
      this.originalContentTitleText = this.description;
    }
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isRephraseInProgress = true;
        this.description = result.rephrasedText;
        console.log("Selected style:", result.selectedStyle);
        this.isRephrased = true;
      }
    });
  }

  GoToOriginalTitleText() {
    this.title = this.originalTitleText;
  }

  async rephraseTitleText(input: string) {
    if (input == undefined || input == "") {
      this.toastManager.warning("The Text To Rephrase is required.");
      return;
    }
  }

  openRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.title },
    });
    if (!this.isTitleRephrased) {
      this.originalTitleText = this.title;
    }
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isTitleRephraseInProgress = true;
        this.title = result.rephrasedText;
        console.log("Selected style:", result.selectedStyle);
        this.isTitleRephrased = true;
      }
    });
  }
  openGetKeyWordsDialog() {
    const dialogRef = this.dialog.open(GenerateKeyword, {
      width: "400px",
      data: { textToRephrase: this.title, textDescrption: this.description },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.predefinedKeywords.length > 0) {
          this.keywords = Array.from(
            new Set([...this.keywords, ...result.predefinedKeywords])
          );
        } else {
          this.toastManager.info(
            "Keyword generation failed. Please provide more specific data in the title and description."
          );
          this.keywords = [];
        }
      }
    });
  }

  setBlogData(blogData) {
    console.log(blogData.hashtags);
    this.coverPageURI = blogData.coverImage;
    this.description = blogData.description;
    this.title = blogData.title;
    this.authorName = blogData.authorName;
    this.duration = parseInt(blogData.duration, 10);
    this.partitionKey = blogData.partitionKey;
    this.featureOnProfile = blogData.featureOnProfile;
    const tags = blogData.hashtags || blogData.Hashtags || "";
    this.keywords = tags
      ? String(tags)
          .split(",")
          .map((tag) => tag.trim())
          .filter(Boolean)
      : [];
    this.embedCode = blogData.embedCode || blogData.EmbedCode || "";
    this.enableEmbed = !!this.embedCode?.trim();
    if (this.enableEmbed) {
      this.embedMethod = "paste";
      const parsed = parseIframeEmbedCode(this.embedCode);
      if (parsed?.src?.includes("/embed/guide-pack/")) {
        this.embedContentType = "bundle";
      } else if (parsed?.src?.includes("/embed/guide/")) {
        this.embedContentType = "flow";
      }
    } else {
      this.clearEmbedWizardState();
    }
    this.refreshJourneyTabs();
    this.showImage = true;
    this.updateEmbedPreview();
    console.log(this.keywords);
  }

  onEmbedCodeChange(): void {
    this.cachedEmbedCodeForValidation = "";
    this.cachedEmbedCodeValid = false;
    this.updateEmbedPreview();
  }

  private updateEmbedPreview(): void {
    if (!this.enableEmbed || !this.embedCode?.trim()) {
      this.embedPreviewUrl = null;
      this.lastEmbedPreviewSrc = null;
      return;
    }

    const parsed = parseIframeEmbedCode(this.embedCode);
    if (!parsed?.src) {
      this.embedPreviewUrl = null;
      this.lastEmbedPreviewSrc = null;
      return;
    }

    // Avoid re-creating SafeResourceUrl (and reloading iframe) for the same src
    if (parsed.src === this.lastEmbedPreviewSrc) {
      return;
    }

    this.lastEmbedPreviewSrc = parsed.src;
    this.embedPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      parsed.src
    );
  }
}
